import type { ResourceArticle, ResourceCategory, ResourceFaq } from "../types";

import newbornImageSrc from "../assets/images/newborn-sleeping-baby-pink-knit-studio-portrait.webp";
import babyImageSrc from "../assets/images/baby-pink-floral-bonnet-studio-portrait.webp";
import maternityImageSrc from "../assets/images/maternity-blue-gown-pine-forest-portrait.webp";
import familyImageSrc from "../assets/images/family-maternity-woodland-walk-portrait.webp";
//import familyImageSrc from "../assets/images/family-maternity-woodland-walk-portrait.webp";
import charlotteImageSrc from "../assets/images/maternity-outdoor-fall-red-gown investment.webp";
import faqImageSrc from "../assets/images/family-fall-outfit-portrait.webp";
import newbornIcon from "../assets/icons/newborn.svg";
import maternityIcon from "../assets/icons/maternity.svg";
import familyIcon from "../assets/icons/family.svg";
import babyIcon from "../assets/icons/baby.svg";
import charlotteIcon from "../assets/icons/charlotte.svg";
import faqIcon from "../assets/icons/faq.svg";

// When you have the final photos, import them here and assign them to imageSrc.
// Example: import newbornCardImage from "../assets/images/categories/newborn.jpg";
export const categories: ResourceCategory[] = [
  {
    id: "newborn",
    title: "Newborn",
    description: "Guides to prepare for your newborn session.",
    href: "/resources/newborn/",
    iconSrc: newbornIcon,
    imageSrc: newbornImageSrc,
    imageAlt: "Sleeping newborn baby in a soft pink knit outfit during a studio portrait session",
    accent: "peach",
  },
  {
    id: "baby",
    title: "Baby",
    description: "Simple guidance for a calm, beautiful experience.",
    href: "/resources/baby/",
    iconSrc: babyIcon,
    imageSrc: babyImageSrc,
    imageAlt: "Baby wearing a pink outfit and floral bonnet during a studio portrait session",
    accent: "sage",
  },
  {
    id: "maternity",
    title: "Maternity",
    description: "Everything you need to know for maternity photos.",
    href: "/resources/maternity/",
    iconSrc: maternityIcon,
    imageSrc: maternityImageSrc,
    imageAlt: "Expectant mother wearing a blue gown during a maternity portrait session in a pine forest",
    accent: "blush",
  },
  {
    id: "family",
    title: "Family",
    description: "Tips for beautiful family sessions.",
    href: "/resources/family/",
    iconSrc: familyIcon,
    imageSrc: familyImageSrc,
    imageAlt: "Expectant parents walking with their daughter during a family maternity session in the woods",
    accent: "blue",
  },

  {
    id: "charlotte",
    title: "Charlotte",
    description: "Local guides, locations and seasonal inspiration.",
    href: "/resources/charlotte/",
    iconSrc: charlotteIcon,
    imageSrc: charlotteImageSrc,
    imageAlt: "Outdoor maternity photography location in the Charlotte area",
    accent: "sand",
  },
  {
    id: "faq",
    title: "FAQ",
    description: "Answers to common questions.",
    href: "/resources/faq/",
    iconSrc: faqIcon,
    imageSrc: faqImageSrc,
    imageAlt: "Family portrait in coordinated fall clothing",
    accent: "lilac",
  },
];

export const latestGuides: ResourceArticle[] = [
  {
    eyebrow: "NEWBORN",
    title: "What to Expect During a Newborn Session",
    description: "A gentle look at how we make the session relaxed, safe and unhurried.",
    href: "/resources/newborn/what-to-expect-during-a-newborn-session/",
    publishedAt: "May 20, 2024",
    readTime: "6 min read",
  },
  {
    eyebrow: "MATERNITY",
    title: "What to Wear for Maternity Photos",
    description: "Simple, timeless outfit ideas that still feel entirely like you.",
    href: "/resources/maternity/what-to-wear-for-maternity-photos/",
    publishedAt: "May 15, 2024",
    readTime: "5 min read",
  },
  {
    eyebrow: "FAMILY",
    title: "Best Time of Day for Family Photos",
    description: "How to choose light and a schedule that works beautifully with little ones.",
    href: "/resources/family/best-time-of-day-for-family-photos/",
    publishedAt: "May 10, 2024",
    readTime: "4 min read",
  },
];

export const charlotteGuides: ResourceArticle[] = [
  {
    eyebrow: "CHARLOTTE, NC",
    title: "Best Parks for Family Photos",
    description: "Beautiful green spaces with room to play, soft light and a relaxed atmosphere.",
    href: "/resources/charlotte/best-parks-for-family-photos/",
  },
  {
    eyebrow: "CHARLOTTE, NC",
    title: "Best Outdoor Locations",
    description: "A photographer's favorite local places for a timeless family session.",
    href: "/resources/charlotte/best-outdoor-photo-locations/",
  },
  {
    eyebrow: "CHARLOTTE, NC",
    title: "Seasonal Blooms Guide",
    description: "When and where to find Charlotte's loveliest spring and summer color.",
    href: "/resources/charlotte/seasonal-blooms-guide/",
  },
];

export const faqs: ResourceFaq[] = [
  {
    question: "What is the best age for newborn photos?",
    answer:
      "The first two weeks are often ideal for sleepy, curled portraits, but beautiful newborn photographs are possible at later ages too.",
    href: "/resources/newborn/best-age-for-newborn-photos/",
  },
  {
    question: "When is the best time to take maternity photos?",
    answer:
      "For most pregnancies, 28–34 weeks offers a beautifully defined bump while there is usually still enough comfort and mobility for the session.",
    href: "/resources/maternity/when-is-the-best-time-to-take-maternity-photos/",
  },
  {
    question: "What is the best age for baby photos?",
    answer:
      "Six to nine months is especially versatile, but 3, 6, 9 and 12 months each capture a different and meaningful milestone.",
    href: "/resources/baby/what-is-the-best-age-for-baby-photos/",
  },
];
